/**
 * @author vishwadeep.kapoor
 * MyEGiftCards actions
 */
import endPoints from '../../config/endPoints';
import { utils, constants } from '../../devUtils';
import * as reqHandler from '../../config/services/serviceHandler';
import { rootApiResponse, clearDefaultError } from '../HeaderContainer/actions';
import { MY_E_GIFT_CONSTANTS } from './constants';
import { DEFAULT_ACTION as DEFAULT_ACTION_EMAIL_VERIFICATION } from '../EmailVerification/constants';

const { DEFAULT_ACTION, FETCH_GIFTCARD_SUCCESS, SET_OTP_GIFTCARD_SUCCESS, SET_GIFTCARD_ACTIVATE_SUCCESS } = MY_E_GIFT_CONSTANTS;

const defaultAction = (payload = true) => ({ type: DEFAULT_ACTION, payload });
const fetchEvouchersDetials = (payload) => ({ type: FETCH_GIFTCARD_SUCCESS, payload });
const activateZscSuccess = (payload) => ({ type: SET_GIFTCARD_ACTIVATE_SUCCESS, payload });
const activateZscOtpSuccess = (payload) => ({ type: SET_OTP_GIFTCARD_SUCCESS, payload });

// const GET_API_EVOUCHER = (api, payload, authPrerequist) => reqHandler.getHandler(api, endPoints.GET_GIFT_EVOUCHERS, payload, authPrerequist);
/** Removed the above API call for e-voucher due to PROP-2388 changes done by NagaAditya on backend */
const GET_API_EVOUCHER = (api, payload, authPrerequist) => reqHandler.getHandler(api, endPoints.GET_GIFT_EVOUCHERS, payload, authPrerequist);

export const fetcheVoucherDetails = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(defaultAction());
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const { evouchers, pagination: { total_count: totalRecords } = {}, message } = await GET_API_EVOUCHER(api, payload, authPrerequist);
    if (evouchers !== undefined && message) {
      dispatch(rootApiResponse(utils.successResponse('activateEvoucher', message)));
    } else if (evouchers === undefined && message) {
      throw (message); /** TODO:: use this message at the last */
    }
    dispatch(fetchEvouchersDetials({ evouchers, totalRecords }));
  } catch (err) {
    dispatch(fetchEvouchersDetials({ evouchers: [], totalRecords: 0 }));
    dispatch(defaultAction(false));
    dispatch(rootApiResponse(utils.errorResponse('E-Voucher', err)));
  }
};

export const activateEvoucher = ({ token }) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION, true));
    dispatch(clearDefaultError());
    const URL = utils.stringReplace(endPoints.GET_ACTIVATE_GIFT_EVOUCHERS, ':token', token);
    const { message } = await reqHandler.getHandler(api, URL);
    if (message) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
      dispatch(activateZscSuccess({ isOtpSend: true }));
      dispatch(rootApiResponse(utils.successResponse('activateEvoucher', message)));
    } else {
      throw (constants.ALERT_DEFAULT);
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
    dispatch(rootApiResponse(utils.errorResponse('activateEvoucher', err)));
  }
};

export const submitEVoucherOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION, true));
    dispatch(clearDefaultError());
    const URL = utils.stringReplace(endPoints.GET_GIFT_EVOUCHERS_OTP, ':token', payload.id);
    const { evouchers, message } = await reqHandler.getHandler(api, URL, payload);
    if (message) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
      dispatch(rootApiResponse(utils.successResponse('submitEVoucherOtp', message)));
    } else if (evouchers) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
      dispatch(activateZscOtpSuccess(evouchers));
    } else {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION_EMAIL_VERIFICATION));
    dispatch(rootApiResponse(utils.errorResponse('submitEVoucherOtp', err)));
  }
};



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/actions.js